import { Stack } from "@mantine/core"
import { IconCheck, IconX } from "@tabler/icons-react"
import { Button, Missing, Badge } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import styles from "~/assets/css/StandardCell.module.css"
import { FindProductsProductStandardDto } from "~/gen/api"

interface Props {
  value: FindProductsProductStandardDto | undefined
  onClick: (standard: FindProductsProductStandardDto, productId: string) => void
  productId: string
}

export const StandardCell = ({ value, onClick, productId }: Props) => {
  const { t } = useTranslation("certificates")

  if (!value) return <Missing />

  return (
    <Stack>
      <Button
        onClick={() => onClick(value, productId)}
        h="fit-content"
        w="max-content"
        bg="none"
        p="compact-xs"
        className={styles.standardCell}
      >
        <Badge
          p={0}
          isShort={true}
          h="fit-content"
          {...(value.complianceDetails.isCompliant
            ? {
                text: t("standard.badge.compliant"),
                variant: "success",
                icon: <IconCheck size={16} />,
              }
            : {
                text: t("standard.badge.notCompliant"),
                variant: "error",
                icon: <IconX size={16} />,
              })}
        />
      </Button>
    </Stack>
  )
}
